import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const getAllBlogs = async (page = 0, rowsPerPage, filterStatus) => {
  try {
    const response = await api.get(
      `${BASE_URL}/blog?page=${page}&limit=${rowsPerPage}&status=${filterStatus}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error?.response?.data || new Error("Failed to fetch blogs");
  }
};

export const getBlogDetails = async (blogId) => {
  try {
    const response = await api.get(`${BASE_URL}/blog/${blogId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error?.response?.data || new Error("Failed to fetch blog details");
  }
};

export const createBlog = async (formData) => {
  try {
    const response = await api.post(`${BASE_URL}/blog`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating blog:", error);
    throw error?.response?.data || new Error("Failed to create blog");
  }
};

export const updateBlog = async (blogId, formData) => {
  try {
    const response = await api.put(`${BASE_URL}/blog/${blogId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error?.response?.data || new Error("Failed to update blog");
  }
};

export const deleteBlog = async (blogId) => {
  try {
    const response = await api.delete(`${BASE_URL}/blog/${blogId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error?.response?.data || new Error("Failed to delete blog");
  }
};
